export enum AlertTypeEnum {
  ScanBadBarcode = 1,
  IncorrectModality = 2,
  MissingPractitioner = 3,
  ImportToNonActiveSurvey = 4,
  TooManyResponsesImport = 5,
  ImportResponseOutOfRange = 6,
  MissingPrimaryContact = 7,
  ResponsesReceived50Per = 8,
}
